<template>
    <thead>
        <tr>
            <th v-for="column in columns.headings" v-html="column.value"
                :style="{ textAlign: retrieveAlignment(column)}"
                :class="retrieveClasses(column)"
                scope="col"
            ></th>
        </tr>
    </thead>
</template>

<script>
    import Widget from './Widget.vue';

    export default {
        extends: Widget,
        props: [
            'columns'
        ]
    }
</script>
